import {createAsyncThunk} from '@reduxjs/toolkit';

import {getMosaicRules} from '@explorer/api/mosaics';

/* Get AOI availability */
export const fetchBasemapRules = createAsyncThunk('basemapRules/fetch', () => {
  return getMosaicRules();
});
